//
//
//
//
//
//
//
//

import {base} from '../../common/mixins'
import Checkbox from './Checkbox'
import Group from '../Group'
const {Cell} = Group

export default {
  Checkbox,
  name: 'Check',
  components: {
    Checkbox,
    Group,
    Cell,
  },
  mixins: [base],
  props: {
    options: {
      // checkbox 选项列表
      type: Array,
      default: null,
    },
    max: {
      // 最大可选数，默认0（无限制），为1时为单选
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
      optionsCopy: [], // 对象形式的options副本
    }
  },
  computed: {
    _max () { // 实际多选值
      return this.max > this.options.length ? 0 : this.max
    },
    isRadio () {
      return this._max === 1
    },
  },
  watch: {
    options () {
      this.init()
    },
  },
  created () {
    this.checkedQueue = [] // checked = true 的项目 _id 队列，不包含 disabled = true 的项目
    this.init()
  },
  methods: {
    init () {
      this._initOptions()
      this._max && this._initMax()
    },

    // 初始化 options 数据结构
    _initOptions (options = this.options) {
      this.optionsCopy = this.options.map((item, index) => {
        if(typeof item === 'object') return {...item, _disabled: false, _id: index, checked: !!item.checked}

        return {
          _id: index, // 选中时需要记录的唯一 id
          _disabled: false, // 多选中超过最大值的 禁用 字段
          label: item,
          value: item,
          checked: false,
          disabled: false,
        }
      })
    },

    // 初始化 max
    _initMax () {
      if(!this._max) return

      this.checkedQueue = []

      if(this.isRadio) { // 单选
        this.optionsCopy.forEach(item => {
          if(item.checked && this.checkedQueue < this._max) {
            this.checkedQueue.push(item._id)
          } else {
            item.checked = false
          }
        })
      } else { // 多选
        const checkedNum = this.optionsCopy.filter(item => item.checked === true).length

        this.optionsCopy.forEach(item => {
          if(item.checked && this.checkedQueue < this._max) {
            this.checkedQueue.push(item._id)
          } else if(this._max <= checkedNum) {
            item._disabled = true
          }
        })
      }
    },

    // 处理 max
    _handleMax (option) {
      if(this.isRadio) { // 单选
        this.optionsCopy.forEach(item => {
          if(item._id !== option._id) item.checked = false
        })
      } else { // 多选
        if(option.checked) {
          this.checkedQueue.push(option._id)
          if(this.checkedQueue.length >= this._max) {
            this.optionsCopy.forEach(item => {
              if(this.checkedQueue.some(id => id === item._id)) {
                item._disabled = false
              } else {
                item._disabled = true
              }
            })
          }
        } else {
          this.optionsCopy.forEach(item => { item._disabled = false })
          const index = this.checkedQueue.indexOf(option._id)
          this.checkedQueue.splice(index, 1)
        }
      }
    },

    // handle
    checkboxChange (val, option, key) {
      if(JSON.stringify(this.optionsCopy[key]) === JSON.stringify(option)) return

      this.$set(this.optionsCopy, key, option)
      this._max && this._handleMax(option)

      this.emitChange(this.optionsCopy)
    },

    // 抛出 change 事件
    emitChange (options) {
      const values = options.filter(item => item.checked === true).map(item => item.value) // 选中的值的数组
      this.$emit('change', values, options)
    },
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Check/index.vue